import { Injectable } from '@angular/core';

import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';

import {
  SecurePayUI,
  SecurePayUICardType,
  SecurePayUIConfig,
  SecurePayUIMode,
  SecurePayUITokenizedCard,
} from '../../../types/secure-pay';
import { environment } from '../../../environments/environment';

declare var securePayUI: any;

@Injectable({
  providedIn: 'root',
})
export class SecurePayService {
  isCardFormLoaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isCardTokenisationInProgress$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isPaymentFormValid$: ReplaySubject<boolean> = new ReplaySubject(1);
  tokenisedCard$: Subject<SecurePayUITokenizedCard> = new Subject();

  private securePay: SecurePayUI;

  init(containerId: string) {
    const config: SecurePayUIConfig = {
      containerId,
      scriptId: 'securepay-ui-js',
      mode: SecurePayUIMode.CHECKOUT,
      clientId: environment.securePayClientId,
      merchantCode: environment.securePayMerchantCode,
      card: {
        allowedCardTypes: [SecurePayUICardType.VISA, SecurePayUICardType.MASTERCARD],
        showCardIcons: true,
        onCardTypeChange: cardType => {
          // card type has changed
        },
        onBINChange: cardBIN => {
          // card BIN has changed
        },
        onFormValidityChange: valid => {
          // form validity has changed
          this.isPaymentFormValid$.next(valid);
        },
        onDCCQuoteSuccess: quote => {
          // dynamic currency conversion quote was retrieved
        },
        onDCCQuoteError: errors => {
          // quote retrieval failed
          console.error('onDCCQuoteError', errors);
        },
        onTokeniseSuccess: tokenisedCard => {
          // card was successfully tokenised or saved card was successfully retrieved
          this.tokenisedCard$.next(tokenisedCard);
          this.isCardTokenisationInProgress$.next(false);
        },
        onTokeniseError: errors => {
          // tokenization failed
          console.error('onTokeniseError', errors);
          this.isCardTokenisationInProgress$.next(false);
        },
      },
      style: {
        backgroundColor: '#ffffff',
        label: {
          font: {
            family: 'Lato, sans-serif',
            size: '12px',
            color: '#222428',
          },
        },
        input: {
          font: {
            family: 'Lato, sans-serif',
            size: '12px',
            color: '#222428',
          },
        },
      },
      onLoadComplete: () => {
        // the UI Component has successfully loaded and is ready to be interacted with
        this.isCardFormLoaded$.next(true);
      },
    };

    this.securePay = new securePayUI.init(config);
  }

  tokenise() {
    this.isCardTokenisationInProgress$.next(true);
    this.securePay.tokenise();
  }

  reset() {
    this.securePay.reset();
  }
}
